const trendChartRouter = [
  {
    path: 'trend-chart',
    name: 'TrendChart',
    component: () => import('@/views/wxapp/bulletin-board/trend-chart/index'),
    meta: {
      title: '利润趋势图'
    }
  }
]

export default trendChartRouter
